import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { Save } from "react-feather";
import { FilePlus } from "react-feather";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";

//FORM
import CreateDeploymentForm from "./CreateDeploymentForm";

interface ModalProps {
  EmpNo: string;
}

const CreateDeploymentModal: React.FC<ModalProps> = ({ EmpNo }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <div className="d-flex justify-content-end">
        <Btn
          color="info"
          onClick={toggle}
          style={{ display: "flex", alignItems: "center", gap: "2px" }}
        >
          <FilePlus size={16} className="me-1" />
          Create Main Deployment
        </Btn>
      </div>

      <Modal
        size="xl"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Create Deployment</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Create a new employee deployment for this employee.{" "}
              <b style={{ color: "red" }}>
                Please review all information carefully before proceeding
              </b>
              .
            </P>
          </ModalHeader>
          <CreateDeploymentForm EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default CreateDeploymentModal;
